export default __webpack_public_path__ + "static/media/motoAutoValorMobile.130ff162.png";